/**
 * Phase 1.7 — QuickLog floating action button.
 *
 * The Phase 1.6 QuickLogSheet stays — this is just the v2 chrome wrapper.
 * Visual change: the button is smaller (h-12 vs h-14), tighter shadow,
 * and renders inside the AppShell so it lives above the rail without
 * needing fixed positioning math.
 *
 * Mobile keeps the bottom-right corner; desktop pins to the bottom-right
 * of the viewport so it doesn't float over the rail.
 */

import { Plus } from 'lucide-react';
import { useState } from 'react';
import { QuickLogSheet } from '@/components/QuickLogSheet';
import { cn } from '@/lib/utils';

export function QuickLogFab(): JSX.Element {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Quick log"
        className={cn(
          'fixed bottom-20 right-4 z-30 inline-flex h-12 w-12 items-center justify-center rounded-full shadow-md transition-all',
          'bg-burnt-orange text-white hover:bg-burnt-orange/90 hover:shadow-lg active:scale-95',
          'dark:bg-burnt-orange-dark dark:hover:bg-burnt-orange-dark/90',
          'md:bottom-6 md:right-6',
          'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-burnt-orange dark:focus:ring-burnt-orange-dark',
        )}
      >
        <Plus className="h-5 w-5" />
      </button>
      <QuickLogSheet open={open} onOpenChange={setOpen} />
    </>
  );
}
